import { useState } from "react";
import { SearchIcon } from "./Icons";

type SearchBarProps = {
  placeholder?: string;
  onSearch?: (query: string) => void;
  className?: string;
  size?: "default" | "large";
  liveSearch?: boolean;
};

export function SearchBar({
  placeholder = "Search plugins...",
  onSearch,
  className = "",
  size = "default",
  liveSearch = false,
}: SearchBarProps) {
  const [query, setQuery] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch?.(query);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setQuery(value);
    if (liveSearch) {
      onSearch?.(value);
    }
  };

  const sizeClasses = {
    default: "h-11 text-sm",
    large: "h-14 text-base",
  };

  return (
    <form onSubmit={handleSubmit} className={`relative w-full ${className}`}>
      <div className="relative w-full">
        <SearchIcon
          className={`absolute left-4 top-1/2 -translate-y-1/2 text-muted ${
            size === "large" ? "h-5 w-5" : "h-4 w-4"
          }`}
        />
        <input
          type="text"
          value={query}
          onChange={handleChange}
          placeholder={placeholder}
          className={`min-w-0 w-full overflow-hidden text-ellipsis rounded-xl border border-elevated bg-surface/50 font-mono text-secondary placeholder-muted outline-none transition-all duration-200 focus:border-amber focus:bg-surface ${sizeClasses[size]} ${
            size === "large" ? "pl-12 pr-4" : "pl-10 pr-4"
          }`}
        />
      </div>
    </form>
  );
}
